import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[sdMaxDate]',
  providers: [{ provide: NG_VALIDATORS, useExisting: SdMaxDateValidator, multi: true }]
})
export class SdMaxDateValidator implements Validator {
  @Input('sdMaxDate') maxDate: string | Date;
  validate(c: AbstractControl): ValidationErrors {
    const date = c.value || null;
    const maxDate = this.maxDate || null;
    if (!date) {
      return null;
    }
    if (!maxDate) {
      return null;
    }
    if (new Date(Date.parseFrom(date, 'dd/MM/yyyy HH:mm')).getTime() > new Date(maxDate).getTime()) {
      return {
        maxDate: true
      };
    }
    return null;
  }
}
